import { styled } from "@mui/material/styles";
import Switch from "@mui/material/Switch";

export const CustomSwitch = styled(Switch)(({ theme }) => ({
  width: 56,
  height: 32,
  padding: 2,
  display: "flex",
  alignItems: "center",
  "& .MuiSwitch-switchBase": {
    padding: 0,
    top: "50%",
    transform: "translateY(-50%)",
    "&.Mui-checked": {
      transform: "translate(24px, -50%)",
      color: theme.palette.custom.background.primary,
      "& + .MuiSwitch-track": {
        border: `1px solid ${theme.palette.custom.foreground.primary}`,
        backgroundColor: theme.palette.custom.foreground.primary,
        opacity: 1,
      },
      "& .MuiSwitch-thumb": {
        width: 32,
        height: 32,
        backgroundColor: theme.palette.custom.background.primary,
        border: `1px solid ${theme.palette.custom.foreground.primary}`,
      },
    },
  },
  "& .MuiSwitch-thumb": {
    width: 32,
    height: 32,
    backgroundColor: theme.palette.custom.background.primary,
    border: `1px solid ${theme.palette.custom.border.default}`,
    boxSizing: "border-box",
  },
  "& .MuiSwitch-track": {
    borderRadius: 60,
    border: `1px solid ${theme.palette.custom.border.default}`,
    backgroundColor: theme.palette.custom.background.secondary,
    opacity: 1,
  },
}));
